import { Configuration, LogLevel } from '@azure/msal-browser';
import { PublicClientApplication } from '@azure/msal-browser/dist/app/PublicClientApplication';

// import { IMsalAuthProviderConfig, LoginType, MsalAuthProvider } from 'react-aad-msal';

// Msal Configurations
export const config: Configuration = {
    auth: {
        authority: 'https://login.microsoftonline.com/c44faee9-8cbc-4913-8e88-f27b92e1c3e4/',
        clientId: process.env.REACT_APP_CLIENT_ID ?? '',
        redirectUri: window.location.origin
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        }
    }
};

export const authProvider = new PublicClientApplication(config);
